(function ($) {
      $('.card--profile-general .show_all').click( function (e) {

        e.preventDefault();
      $(this).prev().removeClass('minimized');

      $(this).css( "display", "none" );
    });
  
  })(jQuery);